import {
  TEMPLATE_ADD_VALIDATION_PROPERTY,
  TEMPLATE_CANCEL_VALIDATION,
  TEMPLATE_EDIT_VALIDATION_PROPERTY,
  TEMPLATE_REMOVE_VALIDATION_PROPERTY,
  TEMPLATE_SAVE_VALIDATIONS,
  TEMPLATE_SELECT_VALIDATION_SETTINGS
} from '../../actions';
import { setIsDirty } from '../../updaters';
import {
  addTemplateValidation,
  cancelTemplateValidation,
  editTemplateValidation,
  removeTemplateValidations,
  saveTemplateValidations,
  updateSelectedValidation
} from './updaters';

export default function validationReducer(draftState, action) {
  const { payload } = action;

  switch (action.type) {
    case TEMPLATE_ADD_VALIDATION_PROPERTY:
      return setIsDirty(addTemplateValidation(draftState, payload));
    case TEMPLATE_EDIT_VALIDATION_PROPERTY:
      return setIsDirty(editTemplateValidation(draftState, payload));
    case TEMPLATE_REMOVE_VALIDATION_PROPERTY:
      return setIsDirty(removeTemplateValidations(draftState, payload));
    case TEMPLATE_CANCEL_VALIDATION:
      return setIsDirty(cancelTemplateValidation(draftState, payload));
    case TEMPLATE_SAVE_VALIDATIONS:
      return setIsDirty(saveTemplateValidations(draftState, payload));
    case TEMPLATE_SELECT_VALIDATION_SETTINGS:
      return setIsDirty(updateSelectedValidation(draftState, payload));
    default:
      return draftState;
  }
}
